// 객체 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역
import logHelper from './logHelper';

// =================================================================================================
// 상수
// =================================================================================================
// string to object
const valueOfString = (s1) => {
  let object1;
  try {
    object1 = JSON.parse(s1); // object 화
  } catch (e) {
    logHelper.error(e);
  }
  return object1;
};

const getPropertyNameList = (aObject) => {
  return Object.getOwnPropertyNames(aObject);
};

// =================================================================================================
// 내보내기
// =================================================================================================
export default {
  getPropertyNameList,
  valueOfString,
};
